import { GivelifyAvatar } from '@givelify/ui';
import { styled } from '@mui/material';

export const Column = styled('div')(({ theme }) => ({
    '& .avatar': {
        width: '100%',
        height: 200,
    },
    '& .full-name': {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(2),
    },
}));

export const AvatarContent = styled('div')({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 16,
});

export const StyledAvatar = styled(GivelifyAvatar)({
    width: 120,
    height: 120,
    fontSize: '40px',
});

export const ButtonContainer = styled('div')({
    display: 'flex',
    justifyContent: 'center',
    position: 'absolute',
    width: 120,
    height: 120,
    overflow: 'hidden',
    backgroundColor: 'transparent',
    borderRadius: '200px',
});

export const UpdateButton = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    marginTop: 82,
    opacity: 0.5,
    width: 120,
    height: 38,
    backgroundColor: theme.legacy.colors.primaryDarkGray,
}));

export const UpdateTextBox = styled('div')({
    position: 'absolute',
    marginTop: 82,
    cursor: 'pointer',
});

export const ActionsWrapper = styled('div')(({ theme }) => ({
    '& .margin-bottom': {
        display: 'none',
        marginBottom: theme.spacing(3),
    },
    '& .label': {
        display: 'inline-block',
    },
    '& .label:hover': {
        cursor: 'pointer',
        textDecoration: 'underline',
    },
    '& svg': {
        marginRight: theme.spacing(1),
    },
    '& svg path': {
        fill: theme.palette.primary.main,
    },
}));

export const ChangePasswordBox = styled('div')({
    display: 'flex',
    alignItems: 'center',
});
